import ALink from './index.vue';
const aLink = {
    install:function(Vue){
        Vue.component('aLink', ALink)
    }
}
export default aLink;


// WEBPACK FOOTER //
// ./src/components/common/aLink/index.js